import Gift from "@sumerkit/icons/gift";
import { FC } from "react";
import styles from "./kit-tag.module.css";

interface KitTagProps {
  className?: string;
}

const KitTag: FC<KitTagProps> = ({ className }) => {
  return (
    <div className={`${styles.kitTag} ${className}`}>
      <Gift className={`${styles.icon}`} />
      <div className={styles.text}>Combo</div>
    </div>);

};

export default KitTag;